import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=21d6feec&scoped=true&"
import script from "./TasksPage.vue?vue&type=script&lang=js&"
export * from "./TasksPage.vue?vue&type=script&lang=js&"
import style0 from "./TasksPage.vue?vue&type=style&index=0&id=21d6feec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6feec",
  null
  
)

export default component.exports